import {useParams} from "react-router";

type FacilitySettingsRouteParams = Readonly<{
  facilityId: string;
}>;

export const useFacilitySettingsParams = () =>
  useParams<FacilitySettingsRouteParams>();
